<template>
	<transition name="fade">
		<div class="spinner" :class="{inline: inline, main : !inline, 'spinner-small' : small}">
			<!--<i class="fa fa-spin fa-spinner fa-4x"></i>-->
			<img :src="spinnerSrc">
			<div v-if="msg" class="msg">
				<div>{{msg}}</div>
			</div>
		</div>
	</transition>
</template>

<script type="text/javascript">
	export default {
		name: "Spinner",
		props: ["inline","msg","small"],
		computed: {
			spinnerSrc() {
				return window.apiRoot+"resources/logo_loader_v4.gif"
			}
		}
	}
</script>

<style type="text/css" scoped>
	.spinner {
		text-align: center;
		height: auto;
		width: 154px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		animation-name: pulse;
		animation-duration: 3s;
		animation-iteration-count: infinite;
		/**/
	}

	.spinner.main {
		position: fixed;
		top: calc(50% - 40px);
		left: calc(50% - 76px);
		z-index: 10000;
		padding: 10px;
		background-color: rgba(255,255,255,0.5);
		border-radius: 5px;
	}

	.spinner.inline {
		position: static;
		height: 90px;
		width: 90px;
		padding: 5px;
		padding-top: 7px;
		font-size: 8px;
		display: flex;
		margin: auto;
	}

	.spinner.spinner-small {
		display: inline-block;
	}

	.spinner.spinner-small img {
		width: 40px;
	}

	.spinner .msg {
		padding: 5px;
		color: white;
		background: #111111;
		margin-top: 5px;
		font-family: "Exo 2", sans-serif;
		font-size: 11pt;
	}

	.msg div {
		/*old pulse*/
	}

	.fade-enter, .fade-leave-to {
		opacity: 0;
	}

	.fade-enter-active, .fade-leave-active {
		transition: all 0.5s;
	}

	.fade-enter-to, .fade-leave {
		opacity: 1;
	}

	@keyframes pulse {
		from {
			transform: scale(1,1);
		}
		50% {
			transform: scale(1.2,1.2);
		}
		to {
			transform: scale(1,1);
		}
	}
</style>